<template>
    <div class="settings-panel">
        <div class="settings-panel__inner">
            <mds-section
                v-if="!(hasVAOr529Securities.hasVA !== undefined || hasVAOr529Securities.has529 !== undefined)"
                :size="7"
                :collapsible="includeTax"
                e2e="taxes-section"
                bold
                ref="section"
                border="secondary"
                @mds-section-expanded="expandSection"
                @mds-section-closed="closeSection"
            >
                <template v-slot:mds-section-title>
                    <span :class="{ 'taxes-disabled': !includeTax }">
                        {{ getUILabel(text) }}
                    </span>
                </template>
                <template v-slot:mds-section-actions>
                    <mds-switch
                        :disabled="
                            $store.state.taxes.taxRateInfo.length === 0 || hasVAOr529Securities.hasVA !== undefined || hasVAOr529Securities.has529 !== undefined
                        "
                        v-model="includeTax"
                        e2e="taxes-section-switch"
                        @change="toggleInclude"
                    >
                        {{ getUILabel("common_include") }}
                    </mds-switch>
                </template>
                <template v-slot:default>
                    <taxes-content :mwcId="getMwcIdForChild('content')" ref="content"> </taxes-content>
                </template>
            </mds-section>
            <taxes-summary v-if="!hasVa529 && !expanded && includeTax" :mwcId="getMwcIdForChild('summary')"></taxes-summary>
            <div class="taxes-alert-container" v-if="hasVAOr529Securities.hasVA !== undefined || hasVAOr529Securities.has529 !== undefined">
                <mds-alert e2e="taxes-section-alert" :title="getUILabel('taxes_available_alert_title')" size="small" variation="informational" persistent>
                    {{ taxesAlertLabel }}
                </mds-alert>
            </div>
        </div>
    </div>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import TaxesSummary from "./Summary";
import TaxesContent from "./Taxes";
import * as types from "../store/mutation-types";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import MdsSwitch from "@mds/switch";
import MdsSection from "@mds/section";
import MdsAlert from "@mds/alert";

export default {
    name: "taxes-panel",
    props: {
        text: String
    },
    components: {
        TaxesSummary,
        TaxesContent,
        MdsSection,
        MdsSwitch,
        MdsAlert
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            },
            expanded: false,
            has529: false,
            hasVA: false
        };
    },
    mounted() {
        if (this.hasVa529) {
            this.includeTax = false;
        }
    },
    computed: {
        hasVAOr529Securities() {
            return this.$store.getters["holdings/hasVAOr529Securities"];
        },
        hasVa529() {
            return this.hasVAOr529Securities.hasVA !== undefined || this.hasVAOr529Securities.has529 !== undefined;
        },
        taxesAlertLabel() {
            if (this.hasVAOr529Securities.hasVA !== undefined && this.hasVAOr529Securities.has529 !== undefined) {
                // VA and 529 included
                return this.getUILabel("taxes_available_alert_all");
            } else if (this.hasVAOr529Securities.hasVA !== undefined && this.hasVAOr529Securities.has529 === undefined) {
                // only VA included
                return this.getUILabel("taxes_available_alert_va");
            } else if (this.hasVAOr529Securities.hasVA === undefined && this.hasVAOr529Securities.has529 !== undefined) {
                // only 529 included
                return this.getUILabel("taxes_available_alert_529");
            }
            return "";
        },
        includeTax: {
            get() {
                return this.$store.state.taxes.includeTax;
            },
            set(value) {
                this.$store.commit(`taxes/${types.SET_INCLUDE_TAX}`, value);
            }
        }
    },
    methods: {
        expandSection() {
            this.expanded = true;
        },
        closeSection() {
            this.expanded = false;
        },
        toggleInclude(value, event) {
            this.$refs.section.toggle(event);
        }
    }
};
</script>

<style lang="scss" scoped>
.taxes-disabled {
    color: #9b9b9b;
}
</style>
